import styled, { css } from 'styled-components';
import theme from '../../styles/theme';

interface ContainerProps {
  hasBorder?: boolean;
  isOpen: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  padding: 15px 0;

  &:not(:last-child) {
    border-bottom: 1.5px solid ${theme.colors.colorGray300};
  }

  ${({ hasBorder }) =>
    hasBorder &&
    css`
      border-bottom: 0.4px solid #d5d5d6;
    `}

  ${({ isOpen }) =>
    isOpen &&
    css`
      height: auto;
    `}
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  div {
    img {
      width: 32px;
      height: 32px;
      transform: rotate(0deg);
      transition: all 0.3s;
    }

    &#active img {
      transform: rotate(180deg);
      transition: all 0.3s;
    }
  }
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    font-size: 14px;
    font-weight: ${theme.fontWeight.medium};
    color: #898b8e;
  `}
`;

export const DataListContainer = styled.div<ContainerProps>`
  display: none;
  flex-direction: column;
  margin-top: 14px;

  ${({ isOpen }) =>
    isOpen &&
    css`
      display: flex;
    `}
`;
